var map = {
	"./add.svg": 67797,
	"./arrow-back.svg": 78092,
	"./arrow-down.svg": 22636,
	"./arrow-right-gray.svg": 33700,
	"./arrow-right.svg": 47656,
	"./attention.svg": 57021,
	"./cart-active.svg": 51025,
	"./cart.svg": 70364,
	"./category-active.svg": 85693,
	"./category.svg": 55398,
	"./close.svg": 88164,
	"./go-back.svg": 49839,
	"./home-active.svg": 14085,
	"./home.svg": 90634,
	"./icon-filter.svg": 13216,
	"./minus-gray.svg": 9874,
	"./minus.svg": 48509,
	"./plus-gray.svg": 92432,
	"./plus.svg": 2852,
	"./user-active.svg": 69340,
	"./user.svg": 67416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88238;